import { inject, Injectable } from '@angular/core';
import { Apis } from '../../core/services/apis/apis';
import { FilterCustomersDto } from './dtos/filter-customers.dto';
import { CustomerI } from './interfaces/customer.interface';
import { FilterCustomerTransactionsDto } from './dtos/filter-customer-transactions.dto';

@Injectable({
  providedIn: 'root',
})
export class CustomersApisService {
  private readonly apis = inject(Apis);

  findAllCustomers(filterCustomers: FilterCustomersDto) {
    return this.apis.get<CustomerI[]>('customers', filterCustomers);
  }

  findAllCustomerTransactions(
    customerID: string,
    filterCustomerTransactionsDto: FilterCustomerTransactionsDto
  ) {
    return this.apis.get<CustomerI[]>(
      `transactions/customers/${customerID}`,
      filterCustomerTransactionsDto
    );
  }

  findOneCustomer(customerID: string) {
    return this.apis.get<CustomerI>(`customers/${customerID}`);
  }
}
